import { EFinancingProgram } from '@if/core/types'
import { CalculateTermPlanOptionsDto, TermPlanOptionDto } from '@src/types/TermPlanOptionDto'
import { QueryFunctionContext, useQuery } from '@tanstack/react-query'
import { getApiClient } from '../api-client'

const SCOPE = 'termPlanOptions'

const keysFactory = {
  termAndPlanOptions: (dto: CalculateTermPlanOptionsDto) => [{ scope: SCOPE, ...dto }] as const,
}

const calculateTermAndPlanOptions = async ({
  queryKey: [dto],
}: QueryFunctionContext<ReturnType<(typeof keysFactory)['termAndPlanOptions']>>): Promise<TermPlanOptionDto[]> => {
  const apiClient = getApiClient()
  const response = await apiClient.post<TermPlanOptionDto[]>(
    `Worksheet/${EFinancingProgram.Personal}/CalculateTermAndPlanOptions`,
    dto,
  )
  return response.data
}

export function useCalculateTermAndPlanOptions(
  dto: CalculateTermPlanOptionsDto | null,
): [TermPlanOptionDto[] | null, boolean] {
  const { data, isFetching } = useQuery({
    queryKey: keysFactory.termAndPlanOptions(dto!),
    queryFn: calculateTermAndPlanOptions,
    enabled: dto !== null,
  })

  return [data ?? null, isFetching]
}
